import React from 'react';
import { IconCross } from '@lmn/lastminute-react-icons/lastminute-icons-solid';
import { IconArrowLeft } from '@lmn/lastminute-react-icons/lastminute-icons-linear';
import styled from 'styled-components';
import { theme } from "../../../themes/theme.js";
import { Button } from "../../atoms/Button/index.js";
var CLOSE_ICON_SIZE = 20;
var LEFT_ICON_SIZE = 18;
export var DialogHeaderCloseIcon = function DialogHeaderCloseIcon(_ref) {
  var onClose = _ref.onClose;
  return /*#__PURE__*/React.createElement(DialogCrossIconContainer, null, /*#__PURE__*/React.createElement(StyledIconClose, {
    $size: CLOSE_ICON_SIZE,
    onClick: onClose,
    "data-testid": "dialog-close-btn"
  }, /*#__PURE__*/React.createElement(IconCross, {
    size: CLOSE_ICON_SIZE
  })));
};
export var DialogHeaderLeftIcon = function DialogHeaderLeftIcon(_ref2) {
  var onClose = _ref2.onClose;
  return /*#__PURE__*/React.createElement(DialogLeftIconContainer, null, /*#__PURE__*/React.createElement(StyledIconClose, {
    $size: LEFT_ICON_SIZE,
    onClick: onClose,
    "data-testid": "dialog-close-btn"
  }, /*#__PURE__*/React.createElement(IconArrowLeft, {
    size: LEFT_ICON_SIZE
  })));
};
export var DialogHeader = function DialogHeader(props) {
  var sticky = props.sticky,
    element = props.element,
    title = props.title,
    action = props.action,
    onClose = props.onClose,
    className = props.className,
    stackedDialog = props.stackedDialog;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HeaderContainerStyled, {
    $sticky: sticky,
    className: className
  }, element || /*#__PURE__*/React.createElement(React.Fragment, null, title ? /*#__PURE__*/React.createElement(DialogTitleContainer, {
    $withAction: !!action,
    $horSpacing: stackedDialog ? LEFT_ICON_SIZE : CLOSE_ICON_SIZE
  }, stackedDialog ? /*#__PURE__*/React.createElement(DialogHeaderLeftIcon, {
    onClose: onClose
  }) : /*#__PURE__*/React.createElement(DialogHeaderCloseIcon, {
    onClose: onClose
  }), /*#__PURE__*/React.createElement(DialogTitle, null, title), action && /*#__PURE__*/React.createElement(DialogAction, null, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    appearance: "ghost",
    onClick: action.onClick,
    small: true
  }, /*#__PURE__*/React.createElement(React.Fragment, null, !!action.icon && action.icon, !!action.text && action.text)))) : /*#__PURE__*/React.createElement(DialogOnlyCloseButtonContainer, null, /*#__PURE__*/React.createElement(DialogHeaderCloseIcon, {
    onClose: onClose
  })))));
};
var HeaderContainerStyled = /*#__PURE__*/styled.div.withConfig({
  displayName: "DialogHeader__HeaderContainerStyled",
  componentId: "sc-1w5e8h4-0"
})(["position:relative;box-shadow:", ";> *{border-radius:", " ", " 0 0;}", ""], theme.kallisto.shadow.mediumDownShadow, theme.kallisto.border.radius.radius200, theme.kallisto.border.radius.radius200, function (p) {
  return p.$sticky && "\n      position: sticky;\n      top: 0;\n      left: 0;\n      z-index: 1;\n      width: 100%;\n  ";
});
var StyledIconClose = /*#__PURE__*/styled.span.withConfig({
  displayName: "DialogHeader__StyledIconClose",
  componentId: "sc-1w5e8h4-1"
})(["fill:", ";cursor:pointer;display:flex;flex-direction:column;justify-content:center;"], theme.kallisto.color.icon.static.iconPrimary);
var DialogCrossIconContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "DialogHeader__DialogCrossIconContainer",
  componentId: "sc-1w5e8h4-2"
})(["flex-grow:1;justify-self:flex-start;align-self:center;"]);
var DialogLeftIconContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "DialogHeader__DialogLeftIconContainer",
  componentId: "sc-1w5e8h4-3"
})(["flex-grow:1;justify-self:flex-start;"]);
var DialogTitleContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "DialogHeader__DialogTitleContainer",
  componentId: "sc-1w5e8h4-4"
})(["display:grid;grid-template-columns:", ";background:", ";padding:", ";"], function (_ref3) {
  var $withAction = _ref3.$withAction,
    $horSpacing = _ref3.$horSpacing;
  return $withAction ? '1fr 2fr minmax(0, 1fr)' : "".concat($horSpacing, "px 1fr ").concat($horSpacing, "px");
}, theme.kallisto.color.background.static.backgroundLayer02, theme.kallisto.space.space200);
var DialogOnlyCloseButtonContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "DialogHeader__DialogOnlyCloseButtonContainer",
  componentId: "sc-1w5e8h4-5"
})(["background:", ";padding:", ";display:flex;border-radius:", ";position:absolute;z-index:1;"], theme.kallisto.color.background.static.backgroundLayer02, theme.kallisto.space.space200, theme.kallisto.border.radius.radius200);
var DialogTitle = /*#__PURE__*/styled.span.withConfig({
  displayName: "DialogHeader__DialogTitle",
  componentId: "sc-1w5e8h4-6"
})(["", ";font-weight:bold;padding:0 ", ";text-align:center;align-self:center;"], function (props) {
  return props.theme.kallisto.mixins.font('Title5');
}, theme.kallisto.space.space100);
var DialogAction = /*#__PURE__*/styled.span.withConfig({
  displayName: "DialogHeader__DialogAction",
  componentId: "sc-1w5e8h4-7"
})(["flex-grow:1;justify-self:flex-end;> *{padding:0 ", ";}"], theme.kallisto.space.space50);